import Vue from 'vue';

Vue.component('tip-tap', () => import('./TipTap.vue'));
Vue.component('toggable-tip-tap', () => import('./ToggableTipTap.vue'));
Vue.component('toggable-text-field', () => import('./ToggableTextField.vue'));
Vue.component('toggable-date-picker', () => import('./ToggableDatePicker.vue'));
Vue.component('help-dialog', () => import('./HelpDialog.vue'));
Vue.component('saving-indicator', () => import('./SavingIndicator.vue'));
Vue.component('return-to-list', () => import('./ReturnToList.vue'));
